import { Pipe, PipeTransform } from '@angular/core';

import { TextTools } from 'appshared/text-tools';
import { MiscTools } from 'appshared/misc-tools';

@Pipe({
	name: 'timeback'
})
export class TimeBackPipe implements PipeTransform {
	constructor() { }

	transform(theDate: any, timezone: any = ''): string {
		if (!theDate) return '';
		const asDate: Date = new Date(theDate);
		if (isNaN(asDate.getTime())) return '';

		const numDaysBack: number = MiscTools.diffDays(new Date(), asDate, false);

		if (numDaysBack > 1095.75) {
			if (numDaysBack % 365.25 > 0)
				return Math.floor(numDaysBack / 365.25) + 'y+';
			else
				return Math.floor(numDaysBack / 365.25) + 'y';
		} else if (numDaysBack > 365) {
			if (numDaysBack % 365 > 0)
				return Math.floor(numDaysBack / 365) + 'y+';
			else
				return Math.floor(numDaysBack / 365) + 'y';
		} else if (numDaysBack > 6) {
			return TextTools.formatDate(asDate, 'MMM-dd', '', timezone);
			// return Math.floor(numDaysBack) + 'd';

		} else if (numDaysBack > 1) {
			return TextTools.formatDate(asDate, 'EEE', '', timezone);

		} else {
			let numHours: number = numDaysBack * 24;
			if (numHours > 1)
				return Math.floor(numHours) + 'h';
			else
				return '<1h';
		} // if

		// return numDaysBack.toLocaleString();

		// return MiscTools.diffDays(new Date(), asDate, true).toLocaleString();
	}
}
